export default "__VITE_ASSET__DPxIejAU__"